export default __webpack_public_path__ + "static/media/ttaBackground.34260889.svg";